module.exports = __webpack_public_path__ + "static/media/team16.62564452.png";